// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__wAtxD","title":"Info_title__3Nkuf","links":"Info_links__79_im","link":"Info_link__wYCnH","logo":"Info_logo__3Jl9j"};